<div [appBadge]="count" style="position: relative">
  <div class="native-scroll scrolling">
    <div class="scroll-content">
      @if (itemsLength ) {
        <ng-content></ng-content>
      } @else {
        <span class="no-data">{{ 'TABLE.no_data' | translate }}</span>
      }
    </div>
  </div>
</div>
